
import public_doc_list from './com/home_view/public_doc_list.vue'
import { defineComponent } from 'vue';
import _ from 'lodash';
//import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src
export default defineComponent({
  name: 'HomeView',
  components: { 
    public_doc_list,
   },

  data(){
    return {
      "test1" : "test msg",
      "selected_munu_idx" : 1,
    }
  },
  methods:{

    gotoLinkMenu(menu:number){
      this.$router.push(`/?menu=${menu}`)
      this.selected_munu_idx = menu;
      //this.selected_munu_idx = menu;
    },
    
    isGetMenuActive(v:number){
      return v == this.selected_munu_idx;
    },
  },
  
  mounted() {
    const query = this.$route.query;
    const has_menu = _.has(query,"menu");
    let menu_idx = 1;
    if(has_menu){
      let menu = query["menu"] + "";
      const num_menu = parseInt(menu);
      if(_.isSafeInteger(num_menu)){
        menu_idx = num_menu;
      }
    }
    this.selected_munu_idx = menu_idx;
    console.log(`selected_munu_idx : ${this.selected_munu_idx}`);

    
  },
});
